"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomSessionId = void 0;
const RESERVED = 0xffff;
const DIFF = 9007199254740991 /* SESSION.MAX */ - RESERVED;
/**
 * Generates a random session ID up to 53 bits in size, skips first 0xFFFF
 * values, keeping them reserved for future extensions.
 *
 * @returns Random session ID.
 */
const randomSessionId = () => Math.floor(DIFF * Math.random() + RESERVED);
exports.randomSessionId = randomSessionId;
